import { apiInstances } from '../../../../libs';

const { get } = apiInstances.orderInstance;

export default async function getOrdersToReturn({
  page,
  filter,
  id_warecloud,
}) {
  return await get(
    `/clouders/orders/return-to-pickup-point?page=${page}&filter=${filter}&id_warecloud=${id_warecloud}`
  );
}
